import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Input, { InputLabel } from 'material-ui/Input';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { DatePicker, TimePicker } from 'material-ui-pickers';
import Switch from 'material-ui/Switch';
import moment from 'moment';
import IconButton from 'material-ui/IconButton';
import { GetApp } from 'material-ui-icons'
import { filter, map, remove, union } from 'lodash'

import ContainerHeader from '../../../components/ContainerHeader/index';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import * as esignaturedetails from '../../../actions/esignaturedetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';
import * as fileupload from '../../../actions/fileupload';

import MUISelector from "../../muiselector";
import * as regData from '../../../../appConstants'
class AddeSignature extends Component {

    constructor(props) {
        super(props);
        this.state = {
            setValue: false,
            committee_id: Number(this.props.loginUser.data.committee_id),
            id: this.props.params.id,
            esignature: { documentId: '', documentNumber: '', dueDate: moment().format('YYYY-MM-DD'), status: '', signedPages: '', esignature_user_list: [], notes: '', },
            userfileList: [],
            newfile: '',
            isFileUploaded: false,
            isFileChanged: false,
        };
    }

    componentDidMount() {
        if (this.state.id) {
            this.setState({ setValue: false })
            // console.log('this.state.id', this.state.id)
            // this.props.actions.getTeamUserList('0');
            this.props.actions.geteSignatureDetails(this.state.id);
        }
        else {
            // this.props.actions.getTeamUserList('0');
            this.state.esignature = { documentId: '', documentNumber: '', dueDate: moment().format('YYYY-MM-DD'), status: '', signedPages: '', esignature_user_list: [], notes: '', }
        }
        this.props.actions.getCustomerUserList();
    }

    handleChange(field, e) {
        // console.log(field, e)
        if (field == 'dueDate') {
            // console.log(field, moment(e).format('DD-MM-YYYY'))
            let esignature = Object.assign({}, this.state.esignature, { [field]: moment(e).format('YYYY-MM-DD') });
            // console.log('this.state', esignature)
            this.setState(Object.assign({}, this.state, { esignature: esignature }));
        }
        else {
            // console.log(field, e.target.value)
            let esignature = Object.assign({}, this.state.esignature, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { esignature: esignature }));
        }
        // console.log('this.state', this.state.esignature)
    }

    handleFileSelected(file) {
        const esignature = this.state.esignature

        let newfile = { 'file': file.target.files[0] }
        this.setState({ 'newfile': newfile });
        // console.log(this.state)
        let formData = new FormData();
        formData.append('file', file.target.files[0])
        if (esignature && esignature.fileres && esignature.fileres.fileId) {
            formData.append('request', JSON.stringify(esignature.fileres))
            this.props.actions.updateExistingFile(this.state.id, formData)
            this.setState({ isFileChanged: true });
        }
        else {
            this.props.actions.fileUpload(formData)
            this.setState({ isFileUploaded: true });
        }
        if (this.refs.fileUpload)
            this.refs.fileUpload.value = null;
    }

    async handleSubmit(e) {
        e.preventDefault();
        // console.log(this.state.esignature)
        let esignature = this.state.esignature;
        if (this.state.id) {
            this.props.actions.updateeSignatureDetails(esignature);
        }
        else {
            this.props.actions.addeSignatureDetails(esignature);
        }
        // console.log(this.state.esignature)
    }

    downloadFile(file, e) {
        if (file)
            this.props.actions.fileDownloadEsignaturefiles(file)
    };

    downloadFileSigned(fileId, e) {
        if (fileId) {
            let file = this.state.esignature.fileres;
            file.fileId = fileId;
            this.props.actions.fileDownloadEsignaturefiles(file)
        }
    };
    render() {
        const { match, loginUser, esignatureDetails, params, teamDetails, fileupload } = this.props;
        // console.log('(esignatureDetails && esignatureDetails.Status)', esignatureDetails && esignatureDetails.esignaturedetails)
        let result = null;
        if ((esignatureDetails && esignatureDetails.Status) || (teamDetails && teamDetails.Status)
            || (fileupload && fileupload.Status)) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        if (this.state.id && esignatureDetails && esignatureDetails.esignaturedetails && !this.state.setValue) {
            this.state.esignature = esignatureDetails.esignaturedetails;
            this.setState({ setValue: true, esignature: esignatureDetails.esignaturedetails })
            this.state.esignature.dueDate = moment(this.state.esignature.dueDate).format('YYYY-MM-DD')
            this.state.userfileList = this.state.esignature.esignature_user_list;
            let committee_users = teamDetails.teamuserList;
            let users = this.state.esignature.esignature_user_list;
            map(users, function (el) {
                remove(committee_users, { 'id': el.id })
            });
            this.state.esignature.users = union(users, committee_users);
            // console.log('esignature', this.state.esignature);
        }
        else if (teamDetails && teamDetails.teamuserList && teamDetails.apiGetResult) {
            // this.state.esignature.users = teamDetails.teamuserList;
            let customer_users = teamDetails.teamuserList;
            let esignature_user_list = this.state.esignature.esignature_user_list;
            map(esignature_user_list, function (el) {
                remove(customer_users, { 'id': el.id })
            });
            this.state.esignature.esignature_user_list = union(esignature_user_list, customer_users);
        }

        if (fileupload && fileupload.filedetails && this.state.isFileUploaded) {
            fileupload.filedetails.description = this.state.newfile.filedescription;
            this.state.esignature.fileres = fileupload.filedetails;
            this.setState({ isFileUploaded: false, newfile: '' });
        }
        let _fileList = null
        // console.log('this.state.document.fileCDS', this.state.document.fileCDS)
        const fileList = this.state.userfileList
        if (fileList && fileList.length > 0) {
            _fileList = fileList.map((_data, index) => {
                return (<tr key={index}>
                    <td>{index + 1} </td>
                    <td>{_data.userId} </td>
                    <td>{_data.file_status} </td>
                    <td><IconButton disabled={_data.file_id ? false : true} className="m-3 size-30" onClick={this.downloadFileSigned.bind(this, _data.file_id)}>
                        <GetApp /></IconButton></td>
                </tr>);
            })
        }

        return (
            <div className="slideInUpTiny ">
                {result}
                <ContainerHeader title="Add eSignature" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">

                        <ValidatorForm autoComplete="off" onSubmit={this.handleSubmit.bind(this)}>
                            <Card className="shadow border-0">
                                <CardHeader className="bg-white p-0">
                                    <div className="row p-2">
                                        <div className="col-6 pt-2 pl-4"> {'eSignature Details'}</div>
                                        <div className="col-2 text-right pt-2"> </div>
                                        <div className="col-4">
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-3">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12 pb-4"
                                                name="documentNumber" label="eSignature Number"
                                                validators={['required', regData.regexAlphaNumeric, regData.regexAlphaNumericLength]}
                                                errorMessages={['This field is required', regData.messageAlphaNumeric, regData.messageLength]}
                                                value={this.state.esignature.documentNumber} onChange={this.handleChange.bind(this, 'documentNumber')} />
                                        </div>
                                        <div className="col-3 pb-4">
                                            <DatePicker fullWidth value={this.state.esignature.dueDate ? this.state.esignature.dueDate : moment()}
                                                onChange={this.handleChange.bind(this, 'dueDate')}
                                                animateYearScrolling={false} label="Due Date"
                                                format="DD/MM/YYYY"
                                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />} rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />} />
                                        </div>
                                        <div className="col-6 pb-4">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="signedPages" label="Pages to be Signed"
                                                // placeholder="4,7,12,23"
                                                validators={['required', regData.getCustomExpression(', '), regData.getCustomExpressionLength(', ', 0, 100)]}
                                                errorMessages={['This field is required', regData.getCustomExpMessage(', '), regData.messageLength]}
                                                value={this.state.esignature.signedPages ? this.state.esignature.signedPages : ''} onChange={this.handleChange.bind(this, 'signedPages')} />
                                        </div>
                                        <div className="col-12 pb-4">
                                            <MUISelector userList={this.state.esignature.esignature_user_list} />
                                        </div>
                                        <div className="col-12 pb-4">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                name="notes" label="Notes"
                                                validators={[regData.regexExp, regData.regexExpLength]}
                                                errorMessages={[regData.messageRegexEx, regData.messageLength]}
                                                value={this.state.esignature.notes ? this.state.esignature.notes : ''} onChange={this.handleChange.bind(this, 'notes')} />
                                        </div>
                                        <div className="col-12 text-right">
                                            <label className="m-2">{this.state.esignature && this.state.esignature.fileres ?
                                                this.state.esignature.fileres.fileName : ""}</label>
                                            {this.state.esignature && this.state.esignature.fileres && this.state.esignature.fileres.fileId && <IconButton
                                                className="m-3 size-30" onClick={this.downloadFile.bind(this, this.state.esignature && this.state.esignature.fileres ? this.state.esignature.fileres : null)}>
                                                <GetApp /></IconButton>}
                                            <input type="file" accept="application/pdf" id="fileUpload" ref="fileUpload" className="hidden" onChange={this.handleFileSelected.bind(this)} />
                                            <label htmlFor="fileUpload">
                                                <Button variant="raised" component="span" className="jr-btn bg-primary text-white">{this.state.esignature.fileres ? 'Change file' : 'Choose file'}</Button>
                                                <p class="pt-2">(Maximum size of the file should not exceed 100MB)</p>
                                            </label>
                                        </div>
                                        <div className="col-12">
                                            <div className="table-responsive-material">
                                                <table className="default-table table-unbordered table table-lg table-hover">
                                                    <thead className="th-border-b">
                                                        <tr>
                                                            <th>S.No.</th>
                                                            <th>User Name</th>
                                                            <th>Status</th>
                                                            <th className="status-cell">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {_fileList}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </CardBody>
                            </Card>
                            <div className="col-12 text-right">
                                <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Save</Button>
                                <Button variant="raised" className="jr-btn bg-grey text-white" onClick={() => { this.props.history.push('/esignature/esignature-list') }}>Cancel</Button>
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    // console.log(ownProps)
    const { loginUser, teamDetails, esignatureDetails, fileupload } = state;
    const { match } = ownProps;
    return { match, loginUser, teamDetails, esignatureDetails, params: ownProps.match.params, fileupload }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, loadswitchercommittees, esignaturedetails, fileupload), dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddeSignature));



// WEBPACK FOOTER //
// ./app/esignaturedetails/addesignature/index.js